import React, {memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/product-summary"
import connect from "./connect"
import {SaleSashPosition} from "../../config/constants"

export interface SaleSashProps {
    saleSashUrl: string | null
    saleSashPosition: SaleSashPosition | null
    sashAltText: string
    saleOrClearance: string
    isOnSale: boolean
    templating: {mainTemplate: string; fallbackTemplate: string}
    percentageSavings?: number | null
    shouldShowsSavingsSash: boolean
    shouldShowFurtherReductionsSash: boolean | undefined
}

export const SaleSash = memo(
    ({
        saleSashUrl,
        saleSashPosition,
        sashAltText,
        isOnSale,
        templating,
        saleOrClearance,
        percentageSavings,
        shouldShowsSavingsSash,
        shouldShowFurtherReductionsSash,
    }: SaleSashProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        return (
            <ComponentName
                {...{
                    saleSashUrl,
                    saleSashPosition,
                    sashAltText,
                    isOnSale,
                    saleOrClearance,
                    percentageSavings,
                    shouldShowsSavingsSash,
                    shouldShowFurtherReductionsSash,
                }}
            />
        )
    },
)
SaleSash.displayName = "SaleSash"

export default connect(SaleSash)
